import React from "react";
import arrow from "../../icons/Arrow.png";
import portone from "../../images/portone.png";
import porttwo from "../../images/porttwo.png";

const HomePortfolio = () => {
  return (
    <div className="homeportfolio mt-5 pt-5">
      <div className="container">
        <div className="row">
          <div className="col-lg-12">
            <div className="label-head  ">-- OUR PROJECTS --</div>
            <h1 className="">
              Explore{" "}
              <span className="color-primary">
                Our Portfolio <br />
              </span>
              of Featured Projects
            </h1>
          </div>
          <div className="col-lg-12 ">
            <ul class="nav nav-tabs mt-5 pb-3" id="myTab" role="tablist">
              <li class="nav-item" role="presentation">
                <button
                  class="nav-link active"
                  id="home-tab"
                  data-bs-toggle="tab"
                  data-bs-target="#home-tab-pane"
                  type="button"
                  role="tab"
                  aria-controls="home-tab-pane"
                  aria-selected="true"
                >
                  All
                </button>
              </li>
              <li class="nav-item" role="presentation">
                <button
                  class="nav-link"
                  id="profile-tab"
                  data-bs-toggle="tab"
                  data-bs-target="#profile-tab-pane"
                  type="button"
                  role="tab"
                  aria-controls="profile-tab-pane"
                  aria-selected="false"
                >
                  Interior
                </button>
              </li>
              <li class="nav-item" role="presentation">
                <button
                  class="nav-link"
                  id="contact-tab"
                  data-bs-toggle="tab"
                  data-bs-target="#contact-tab-pane"
                  type="button"
                  role="tab"
                  aria-controls="contact-tab-pane"
                  aria-selected="false"
                >
                  Exterior
                </button>
              </li>
              <li class="nav-item" role="presentation">
                <button
                  class="nav-link"
                  data-bs-toggle="tab"
                  data-bs-target="#residence-tab-pane"
                  type="button"
                  role="tab"
                  aria-controls="residence-tab-pane"
                  aria-selected="false"
                >
                  Residence
                </button>
              </li>

              <li class="nav-item" role="presentation">
                <button
                  class="nav-link"
                  data-bs-toggle="tab"
                  data-bs-target="#Offices-tab-pane"
                  type="button"
                  role="tab"
                  aria-controls="Offices-tab-pane"
                  aria-selected="false"
                >
                  Offices
                </button>
              </li>

              <li class="nav-item" role="presentation">
                <button
                  class="nav-link"
                  data-bs-toggle="tab"
                  data-bs-target="#Kitchen-tab-pane"
                  type="button"
                  role="tab"
                  aria-controls="Kitchen-tab-pane"
                  aria-selected="false"
                >
                  Kitchen
                </button>
              </li>

              <li class="nav-item" role="presentation">
                <button
                  class="nav-link"
                  data-bs-toggle="tab"
                  data-bs-target="#living-tab-pane"
                  type="button"
                  role="tab"
                  aria-controls="living-tab-pane"
                  aria-selected="false"
                >
                  Living Room
                </button>
              </li>

              <li class="nav-item" role="presentation">
                <button
                  class="nav-link"
                  data-bs-toggle="tab"
                  data-bs-target="#bed-tab-pane"
                  type="button"
                  role="tab"
                  aria-controls="bed-tab-pane"
                  aria-selected="false"
                >
                  Bed Room
                </button>
              </li>
            </ul>
            <div class="tab-content" id="myTabContent">
              <div
                class="tab-pane fade show active"
                id="home-tab-pane"
                role="tabpanel"
                aria-labelledby="home-tab"
                tabindex="0"
              >
                <div className="row">
                  <div className="col-lg-6">
                    <div className="portfolio-card">
                      <img src={portone} alt="" className="homebanner-img" />
                      <div className="portfolio-card-wrap">
                        <div className="portfolio-card-wrap-content">
                          <h5 className="color-white">
                            Modern 1 Bhk Apartment <br /> Interior Design
                          </h5>
                          <div className="portfolio-card-wrap-content-list">
                            <h6>Apartment</h6>
                            <h6>Residential Design</h6>
                          </div>
                        </div>
                        <div className="portfolio-card-wrap-content-img">
                          <img src={arrow} alt="" />
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="col-lg-6">
                    <div className="portfolio-card">
                      <img src={porttwo} alt="" className="homebanner-img" />
                      <div className="portfolio-card-wrap">
                        <div className="portfolio-card-wrap-content">
                          <h5 className="color-white">
                          Modern and Luxury 3Bhk  <br /> Apartment Interior Design
                          </h5>
                          <div className="portfolio-card-wrap-content-list">
                            <h6>Apartment</h6>
                            <h6>Residential Design</h6>
                          </div>
                        </div>
                        <div className="portfolio-card-wrap-content-img">
                          <img src={arrow} alt="" />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div
                class="tab-pane fade"
                id="profile-tab-pane"
                role="tabpanel"
                aria-labelledby="profile-tab"
                tabindex="0"
              >
                ...sd
              </div>
              <div
                class="tab-pane fade"
                id="contact-tab-pane"
                role="tabpanel"
                aria-labelledby="contact-tab"
                tabindex="0"
              >
                ...www
              </div>
              <div
                class="tab-pane fade"
                id="residence-tab-pane"
                role="tabpanel"
                aria-labelledby="residence-tab-pane"
                tabindex="0"
              >
                ...ew
              </div>

              <div
                class="tab-pane fade"
                id="Offices-tab-pane"
                role="tabpanel"
                aria-labelledby="Offices-tab-pane"
                tabindex="0"
              >
                ...ew
              </div>

              <div
                class="tab-pane fade"
                id="Kitchen-tab-pane"
                role="tabpanel"
                aria-labelledby="Kitchen-tab-pane"
                tabindex="0"
              >
                ...ew
              </div>
              <div
                class="tab-pane fade"
                id="living-tab-pane"
                role="tabpanel"
                aria-labelledby="living-tab-pane"
                tabindex="0"
              >
                ...ew
              </div>
              <div
                class="tab-pane fade"
                id="bed-tab-pane"
                role="tabpanel"
                aria-labelledby="bed-tab-pane"
                tabindex="0"
              >
                ...ew
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default HomePortfolio;
